import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c79c0446"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "saturation-white" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "saturation-black" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "saturation-circle" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { computed, onUnmounted, ref } from 'vue'
import tinycolor, { type ColorFormats } from 'tinycolor2'
import { throttle, clamp } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'Saturation',
  props: {
    value: {},
    hue: {}
  },
  emits: ["colorChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const color = computed(() => {
  const hsva = tinycolor(props.value).toHsv()
  if (props.hue !== -1) hsva.h = props.hue
  return hsva
})

const bgColor = computed(() => `hsl(${color.value.h}, 100%, 50%)`)
const pointerTop = computed(() => (-(color.value.v * 100) + 1) + 100 + '%')
const pointerLeft = computed(() => color.value.s * 100 + '%')

const emitChangeEvent = throttle(function(param: ColorFormats.HSVA) {
  emit('colorChange', param)
}, 20, { leading: true, trailing: false })

const saturationRef = ref<HTMLElement>()
const handleChange = (e: MouseEvent) => {
  e.preventDefault()
  if (!saturationRef.value) return
  
  const containerWidth = saturationRef.value.clientWidth
  const containerHeight = saturationRef.value.clientHeight
  const xOffset = saturationRef.value.getBoundingClientRect().left + window.pageXOffset
  const yOffset = saturationRef.value.getBoundingClientRect().top + window.pageYOffset
  const left = clamp(e.pageX - xOffset, 0, containerWidth)
  const top = clamp(e.pageY - yOffset, 0, containerHeight)
  const saturation = left / containerWidth
  const bright = clamp(-(top / containerHeight) + 1, 0, 1)

  emitChangeEvent({
    h: color.value.h,
    s: saturation,
    v: bright,
    a: color.value.a,
  })
}


const unbindEventListeners = () => {
  window.removeEventListener('mousemove', handleChange)
  window.removeEventListener('mouseup', unbindEventListeners)
}
const handleMouseDown = (e: MouseEvent) => {
  handleChange(e)
  window.addEventListener('mousemove', handleChange)
  window.addEventListener('mouseup', unbindEventListeners)
}
onUnmounted(unbindEventListeners)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "saturation",
    ref_key: "saturationRef",
    ref: saturationRef,
    style: _normalizeStyle({ background: bgColor.value }),
    onMousedown: _cache[0] || (_cache[0] = $event => handleMouseDown($event))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", {
      class: "saturation-pointer",
      style: _normalizeStyle({
        top: pointerTop.value,
        left: pointerLeft.value,
      })
    }, _hoisted_4, 4)
  ], 36))
}
}

})